var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"secondary_title",staticStyle:{"font-weight":"700"}},[_vm._v("\n  "+_vm._s(_vm.small)+"\n  "),(_vm.sup)?_c('sup',{staticClass:"secondary_title",staticStyle:{"margin-left":"-3px"}},[_vm._v(_vm._s(_vm.sup))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }